import { Component, effect, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import {MatMenuModule} from '@angular/material/menu';
import {MatToolbarModule} from '@angular/material/toolbar'
import {MatSidenavModule} from'@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DashboardService } from '../../services/shared/dashboard.service';
import { SearchService } from '../../services/shared/search.service';


@Component({
  selector: 'app-myfavourite',
  standalone: true,
  imports: [MatCardModule,
    CommonModule,
    MatGridListModule,
    MatListModule,
    FormsModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatSidenavModule,
    MatTooltipModule,
    RouterModule,],
  templateUrl: './myfavourite.component.html',
  styleUrl: './myfavourite.component.scss'
})
export class MyfavouriteComponent implements OnChanges {
  receivedData : any
  selectedFav: string = 'All Categories';
  @Output() onFavChnage = new EventEmitter();
  @Output () parentCate = new EventEmitter();
   @Input()  allcategory: any;
   @Input() promptlist : any;
   @Input() selectedLibrary : any;
   @Input() parentcateName : any;
  totalcount: any;
  tooltipText : string = 'abc'
  tol: any;
  myFavCount: any;
  myPromptsCount: any;
  approvalPendingCount: any;
  parentId: any;
  user_role: any;
  userid: any;
  subcatValue: any;
  activeSubMenu: any = [];
  tooltipStyles: { top: string; left: string } = { top: '0px', left: '0px' };

  constructor ( private dashboardService : DashboardService, private searchService: SearchService ) {
    
    effect(() => {
      let searchData = this.searchService.getSearchData();
      if (Object.keys(searchData).length > 0) {
        this.onFavSelect(searchData);
        this.searchService.setSearchData({})
        // this.updateFavouriteList(searchData);
      }
    }, {allowSignalWrites: true});

  }

  showSubMenu(category: any, event: MouseEvent): void {
    this.activeSubMenu = category;
    const target = event.target as HTMLElement;
    const rect = target.getBoundingClientRect();
    this.tooltipStyles = {
      top: `${rect.top - 8}px`,
      left: `${rect.right - 10}px` // Position to the right of the hovered element
    };
  }

  hideSubMenu(): void {
    this.activeSubMenu = null;
  }

  onFavSelect(fav:any , event: any =null , parentCategory : string = ''){
    this.subcatValue = fav.name;
    this.parentId = parentCategory;
    if (event != null) event.stopPropagation();
    if (typeof fav === 'object') {
      this.selectedFav = fav.name;
    } else {
      this.selectedFav = fav;
    }
    this.onFavChnage.emit(fav);
  }

 
  async ngOnInit() {

    this.dashboardService.currentData.subscribe( (data) => {
      this.receivedData = data
    });

    this.user_role = this.dashboardService.user_role
    this.userid = this.dashboardService.user_id;
   
    let selected_cat = localStorage.getItem("selected_cat");
    let parsed_cat: any;
    // let parsed_cat = selected_cat ? JSON.parse(selected_cat) : null;

    try {
      if(selected_cat != null) {
        let parsedSelectedCat = JSON.parse(selected_cat)
        if (parsedSelectedCat) {
          parsed_cat = parsedSelectedCat
        }
      }
    } catch (e) {
        // If parsing fails, keep it as a string
        parsed_cat = selected_cat;
        
    }

    let searchData = this.searchService.getSearchData();
    if(Object.keys(searchData).length > 0) {
      setTimeout(() => {
        // this.onFavSelect(searchData, null, "", true);
        this.onFavSelect(searchData);
        // this.searchService.setSearchData({})
      }, 2000)
    } else if(selected_cat != null) {
      setTimeout(() => {
        this.onFavSelect(parsed_cat);
      }, 2000)
    }

    // if(selected_cat != null) {
    //   setTimeout(() => {
    //     this.onFavSelect(parsed_cat);
    //   }, 300)
    // }
  }

  ngOnChanges() {
    this.totalcount = this.promptlist?.all_categories_count
    this.myFavCount = this.promptlist?.favourites_count
    this.myPromptsCount = this.promptlist?.my_prompts_count
    this.approvalPendingCount =  this.promptlist?.approval_pending_count
    this.selectedFav = this.selectedLibrary;
    //  this.selectedFav = this.breadcrumb
    this.parentcateName = this.parentcateName
    
  }
 


 
 
  isExpanded = true;
  showSubmenu: boolean = false;
  isShowing = false;
  showSubSubMenu: boolean = false;
  mouseenter() {
    if (!this.isExpanded) {
      this.isShowing = true;
    }
  }

  mouseleave() {
    if (!this.isExpanded) {
      this.isShowing = false;
    }
  }
}